import {} from "../actions/constants/auth";
import {
  CLEAR_PROFILE,
  GET_PROFILES_REQUEST,
  GET_PROFILES_SUCCESS,
  GET_PROFILE_FAIL,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
} from "../actions/constants/profile";

const initialState = {
  profiles: null,
  loading: false,
  error: {},
};

export const profileReducer = (state = { profile: {} }, action: any) => {
  switch (action.type) {
    case GET_PROFILE_REQUEST:
      return { loading: true, profile: {} };
    case GET_PROFILE_SUCCESS:
      return {
        profile: action.payload,
        loading: false,
      };
    case GET_PROFILE_FAIL:
      return { loading: false, error: action.payload };
    case CLEAR_PROFILE:
      return {
        profile: null,
        loading: false
      }
    default:
      return state;
  }
};

export const profileListReducer = (state = initialState, action: any) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PROFILES_REQUEST:
      return { loading: true, profiles: [] };
    case GET_PROFILES_SUCCESS:
      return {
        ...state,
        profiles: payload,
        loading: false,
      };
    default:
      return state;
  }
};
